<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, 코로나 시대
                                공기업 및 대기업 취업 화상교육 진행</h4>
                            <!-- <div class="board_meta">
                                <ul>
                                    <li>등록일 : 22.05.24</li>
                                    <li>조회수 : 142</li>
                                </ul>
                            </div> -->
                        </div>
                        <div class="board_body">
                            <div class="board_content">
                                <figure class="image"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_02.png"></figure>
                                <br>
                                <br>
                                에듀윌이 성균관대, 중앙대 등 전국 대학에서 공기업 및 대기업 취업 교육을 비대면의 화상으로 진행한다고 밝혔다.
                                <br><br>

                                에듀윌은 공기업 NCS, 대기업 직무적성 및 입사 전략 등 다양한 취업 과정을 화상교육으로 진행하며, 화상교육을 통해 학습자가 강사와 자유롭게 소통할 수 있는
                                장점이 있다고 전했다.
                                <br><br>

                                에듀윌 대학사업 관계자는 “코로나19 장기화로 대학들의 비대면 화상교육에 대한 문의가 급속도로 증가하고 있다”면서, “최근 월 평균 3~4곳의 대학에서
                                화상으로 취업 교육을 진행할 정도로 비대면 방식으로 전환하는 대학들이 늘고 있다”고 설명했다.
                                <br><br>

                                서울 소재 모 대학의 취업교육 담당자는 “비대면 수업이지만 실시간으로 강사와 학생이 소통할 수 있다는 장점이 있고, 모니터링도 편하게 할 수 있어 좋다”며,
                                “수강생 만족도도 높아 앞으로도 꾸준히 화상 교육을 이용할 계획”이라고 전했다.
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news1" data-value="315284">
                                        <strong>이전</strong>
                                        <span>에듀윌, 서울시 교육복지사업 ‘서울런’ 참여…검정고시·자격증 최신 강좌 지원</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                                <!-- 다음 보도 기사가 있을 경우 -->
                                <li class="next">
                                    <router-link to="/edu/newsRelease/promotionVideo/news3" data-value="315284">
                                        <strong>다음</strong>
                                        <span>에듀윌, 신한은행과 퇴직연금고객 교육솔루션 MOU 체결</span>
                                    </router-link>
                                </li>
                                <!-- //다음 보도 기사가 있을 경우 -->
                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
